import React from 'react'
import { graphql } from "gatsby"
import PageSection from "../page-sections/PageSection"
import StoryContentCard from "../content-blocks/StoryContentCard"
import CardHandler from "../content-modules/CardHandler"

const RelatedPosts = ({ postProduct, postId, data }) => {
  const { products, recentPosts } = data

  /**
   * default is to return a Recent Posts section instead of Related, 
   * so we'll set up the values for that first
   */
  let heading = "Featured News and Stories"
  let buttonText = "See All News and Stories"
  let buttonLink = "/news/all"
  let postItems = null
  let displayPosts = recentPosts

  if (postProduct) {
    let { nodes } = products
    const displayPostNodes = nodes.find( o => o.id == postProduct.id)
    const { posts, slug } = displayPostNodes
    displayPosts = posts
    /* override heading, button link */
    heading = "Related News and Stories"
    buttonLink = `/news/all/?product=${slug}`
  }

  /* filter the current post out of the list */
  displayPosts.nodes = displayPosts.nodes.filter(function(o) {
    return o.id !== postId
  })
  postItems = displayPosts?.nodes.slice(0,10)

  return (
    <PageSection 
      id="post-listing" 
      heading={heading}
      topBorder 
      buttons={[
        {
          link: buttonLink,
          text: buttonText,
        },
      ]}
      >
      <CardHandler items={postItems} size="M" sliderSize="S" type="news" />
    </PageSection>
  )
}


export default RelatedPosts

export const query  = 
    graphql`
      query relatedPostsQuery {
        products: allWpProduct {
          nodes {
            id
            slug
            posts{
              nodes {
                id
                title
                url: uri
                excerpt
                categories {
                  nodes {
                    name
                    slug
                    id
                  }
                }
                products {
                  nodes {
                    name
                    slug
                    id
                  }
                }
                featuredImage {
                  node {
                    altText
                    localFile {
                      childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, width: 1080)
                      }
                    }
                  }
                }
                askFlamingle {
                  abeQuestioner
                }
                acfAlternatePostType{
                  alternateposttype
                }
                videoFormat {
                  vimeoId
                }
                linkFormat {
                  linkAuthor
                  linkUrl
                }
                postExternalAuthors {
                  nodes {
                    name
                    slug
                  }
                }
              }
            }
          }
        }
        recentPosts: allWpPost(limit: 10, sort: {date: DESC}) {
          nodes {
            title
            excerpt
            featuredImage {
              node {
                localFile {
                  ...HeroImageNew
                }
              }
            }
            url: uri
            categories {
              nodes {
                name
                slug
              }
            }
            products {
              nodes {
                name
                slug
              }
            }
          }
        }
      }
    `


